import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        instanciaPhone: "",
        registro: "",
        stateCrono: "reset",
        nombreLLamadaEntrante: "",
        llamadaEstado: "",
        verColgar: false,
        extensiontransferencia:"",
        iniciarBotonera:false
    },
    mutations: {
        SET_INSTANCIAPHONE(state, instanciaPhone) {
            state.instanciaPhone = instanciaPhone;
        },
        SET_REGISTRO(state, registro) {
            state.registro = registro;
        },
        SET_STATECRONO(state, stateCrono) {
            state.stateCrono = stateCrono;
        },
        SET_NOMBRELLAMADAENTRANTE(state, nombreLLamadaEntrante) {
            state.nombreLLamadaEntrante = nombreLLamadaEntrante;
        },
        SET_LLAMADAESTADO(state, llamadaEstado) {
            state.llamadaEstado = llamadaEstado;
        },
        SET_VERCOLGAR(state, verColgar) {
            state.verColgar = verColgar;
        },
        SET_EXTENSIONTRANSFERENCIA(state, extensiontransferencia) {
            state.extensiontransferencia = extensiontransferencia;
        },
        SET_INICIARBOTONERA(state, iniciarBotonera) {
            state.iniciarBotonera = iniciarBotonera;
        },
    },
    getters: {
        getinstanciaPhone(state) {
            return state.instanciaPhone
        },
        getregistro(state) {
            return state.registro
        },
        getstateCrono(state) {
            return state.stateCrono
        },
        getnombreLLamadaEntrante(state) {
            return state.nombreLLamadaEntrante
        },
        getllamadaEstado(state) {
            return state.llamadaEstado
        },
        getverColgar(state) {
            return state.verColgar
        },
        getextensiontransferencia(state) {
            return state.extensiontransferencia
        },
        getiniciarBotonera(state) {
            return state.iniciarBotonera
        },
    },
    actions: {
        setinstanciaPhone(context, instanciaPhone) {
            context.commit('SET_INSTANCIAPHONE', instanciaPhone)
        },
        setregistro(context, registro) {
            context.commit('SET_REGISTRO', registro)
        },
        setstateCrono(context, stateCrono) {
            context.commit('SET_STATECRONO', stateCrono)
        },
        setnombreLLamadaEntrante(context, nombreLLamadaEntrante) {
            context.commit('SET_NOMBRELLAMADAENTRANTE', nombreLLamadaEntrante)
        },
        setllamadaEstado(context, llamadaEstado) {
            context.commit('SET_LLAMADAESTADO', llamadaEstado)
        },
        setverColgar(context, verColgar) {
            context.commit('SET_VERCOLGAR', verColgar)
        },
        setextensiontransferencia(context, extensiontransferencia) {
            context.commit('SET_EXTENSIONTRANSFERENCIA', extensiontransferencia)
        },
        setiniciarBotonera(context, iniciarBotonera) {
            context.commit('SET_INICIARBOTONERA', iniciarBotonera)
        },
    },
})
